<template>
  <div id="app" v-bind:class="{loading: this.loading}">
    <resize-observer @notify='handleResize' />
    <div class="row">
      <div class="columns" >
        <div class="members-toggle">
            <div id="memberTop" class="members-toggle--wrap">
              <a  class="members-toggle--btn active guild-members" href="#" data-id="members" v-on:click="(showLoader(), toggle($event), getMembers(api), showHideFilter(), sendHiddenState())">Guild Members </a>
              <a class="members-toggle--btn business-affiliates" href="#" data-id="affiliates"  v-on:click="( showLoader(), toggle($event), baSearch(), showHideFilter(), sendHiddenState())" > Business Affiliates </a>
              <span/>
            </div>
        </div>
      </div>
    </div>
    <div class="row centered">
       <div class="bouncing-loader_filter" v-bind:class="{loading: this.loading}">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
      <div class="columns margin-wide member-filter-container active filters">
        <div id="memberTop" class="filter-bar" >
          <button v-on:click.prevent="filterOpenClose" class="filterCollapse">Member Search Filters <span v-if="this.filterNumber >0" >{{this.filterNumber}}</span>
          <div v-if="this.isActive" class="arrow-container">
                      <img  src="/NationalGuild/assets/up@2x.png" alt="">

          </div>
          <div v-else class="arrow-container">
                      <img  src="/NationalGuild/assets/down@2x.png" alt="">

          </div>
          </button>
        </div>
        <div class="filter-container member" id='filterContainer' v-bind:class="{active: this.isActive}">
          <div class="filter-upper_container">
            <div class="input-container state">
              <label for="state">{{this.stateLabel}}</label>
              <div class="select-container">
              <select name="state" id="state" v-model="search.states"  v-on:change.prevent="getCities(), setPageToOne(), getFilterNumber()"  class="filter hide-on-collapse" >
                <option class="selected" value="" selected>All States</option>
                <option v-for="state in this.filterFields.states" v-bind:value="Object.keys(state)[0]" >{{parseValue(state)}}</option>
                </select>
              </div>
            </div>
            <div class="input-container city">
              <label for="city">{{this.cityLabel}}</label>
              <div class="select-container">
              <select v-on:change.prevent="setPageToOne(), getFilterNumber()" name="city" id="city" v-model="search.cities" v-bind:disabled="!search.cities" class="filter hide-on-collapse">
                <option value="" selected>All Cities</option>

              </select>
              </div>
            </div>
            <div class="input-container keyword">
              <label for="keyword">{{this.keyWordLabel}}</label>
              <!-- <form action="" v-on:submit.prevent="showLoader(), getMembers(api), filterClose()"> -->
              <input @keydown="submitOnEnter($event)" v-on:change="setPageToOne(), getFilterNumber()"  v-model="search.keyword" type="text" class="hide-on-collapse" name="keyword" id="keyword" placeholder="enter keyword"/>
              <!-- </form> -->
            </div>
          </div>
          <div class="filter-lower_container">
            <div class="filter-lower_container-half">
              <div class="input-container institution">
                <label for="institutionType">{{this.institutionaLabel}}</label>
                <div class="select-container">
                <select v-on:change="setPageToOne(), getFilterNumber()" name="institutionType" id="institutionType" v-model="search.institutionType" class="hide-on-collapse filter" >
                  <option value="" selected>All Institution Types</option>
                  <option v-for="institutionTyp in this.filterFields.institutionType" v-bind:value="institutionTyp" >{{institutionTyp}}</option>
                </select>
                </div>
              </div>
              <div v-if="this.showBudget" class="input-container  budget">
                <label for="Budget">{{this.budgetLabel}}</label>
                <div class="select-container ">
                <select  v-on:change="setPageToOne(), getFilterNumber()" name="Budget" id="Budget" v-model="search.budgets" class="hide-on-collapse filter">
                  <option value="" selected>All Budgets</option>
                  <option v-for="budget in this.filterFields.budgets" v-bind:value="Object.keys(budget)[0]" >{{parseValue(budget)}}</option>
                </select>
                </div>
              </div>
              <div v-else class="input-container disabled budget">
                <label for="Budget">{{this.budgetLabel}}</label>
                <div class="select-container disabled">
                <select  class="filter hide-on-collapse" disabled name="budget" id="budget">
                  <option value="" selected>All Budgets</option>
                </select>
                </div>
                <p class="login-message">
                  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9">
                  <path fill="#898989" fill-rule="evenodd" d="M6.77348384,84.8157396 L6.45271554,84.8157396 L6.0082359,84.8157396 L6.0082359,83.8179882 C6.00849508,83.8137278 6.00849508,83.8095858 6.00849508,83.8059172 C6.00849508,82.2588166 5.08964465,81 3.95991476,81 C2.83053044,81 1.91159362,82.2588166 1.91159362,83.8059172 L1.91159362,84.8157396 L1.54719806,84.8157396 L1.22642976,84.8157396 C1.10124978,84.8157396 1,84.9544379 1,85.1259172 L1,89.6898225 C1,89.8611834 1.10124978,90 1.22642976,90 L6.77357024,90 C6.89875022,90 7,89.8613018 7,89.6898225 L7,85.1259172 C6.99991361,84.9545562 6.89866383,84.8157396 6.77348384,84.8157396 L6.77348384,84.8157396 Z M3.11795197,83.8059172 C3.11795197,83.1698225 3.49556528,82.6531361 3.95991476,82.6531361 C4.42132696,82.6531361 4.79747164,83.1643787 4.80196395,83.7950296 C4.80196395,83.796213 4.80170477,83.7975148 4.80170477,83.7986982 L4.80196395,83.7986982 L4.80196395,83.8059172 L4.80196395,84.8157396 L3.11795197,84.8157396 L3.11795197,83.8059172 L3.11795197,83.8059172 Z" transform="translate(-1 -81)"/>
                </svg>
                  Login to enable filter.</p>
              </div>
            </div>
            <div class="filter-lower_container-half">
              <fieldset class="disciplines">
                <legend>{{this.disciplinelabel}}<button class="hide-on-collapse" v-on:click.prevent="filterResetDisciplines">(Clear all)</button></legend>
                <div class="disciplines_container">
                    <span class="checkbox-container" v-for="discipline in this.filterFields.disciplines">
                      <input @keydown="preventEnterSubmit($event)" class="hide-on-collapse" v-on:change.prevent="setPageToOne(), getFilterNumber()" v-model="search.disciplines" type="checkbox" v-bind:id=discipline v-bind:name=discipline v-bind:value=discipline >
                      <label tab-index="1" v-bind:for=discipline>{{discipline}}</label>
                    </span>
                  </div>
              </fieldset>
              <fieldset class="program-types">
                <legend>{{this.programsLabel}}<button class="hide-on-collapse" v-on:click.prevent="filterResetProgramTypes">(Clear all)</button></legend>
                  <div class="program-types_container">
                    <span class="checkbox-container" v-for="(programType, index) in this.filterFields.programTypes">
                      <input @keydown="preventEnterSubmit($event)" class="hide-on-collapse" v-on:change.prevent="setPageToOne(), getFilterNumber()" v-model="search.programTypes" type="checkbox" v-bind:id="programType.toLowerCase()"  v-bind:name=programType.toLowerCase() v-bind:value=programType>
                      <label v-bind:for=programType.toLowerCase()>{{programType}}</label>
                    </span>
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="button-bar" >
              <button class="button dark hide-on-collapse" v-on:click.prevent="showLoader(), getMembers(api), filterClose(), getFilterNumber(), sendHiddenState()">Apply filters</button>
              <button v-on:click.prevent="filterReset(), sendHiddenState()" class="hide-on-collapse button light">Reset filters</button>
            </div>
          </div>
        </div>
    </div>
    <div v-if="bigTotalItems > 0"  class="row filter-under">
      <div class="medium-6 columns margin-wide ">
        <p  class="results-total">Showing {{ bigTotalItems }} Members</p>
      </div>
      <div  class="medium-6 columns margin-wide">
        <ContactListBtn />
      </div>
    </div>
    <section v-if="results.length >= 1"  class="member-listing has-after" >
      <MemberList :results="results"/>
      <div class="row">
        <div v-if="this.search.searchType==='MD'"  class="member-pagination">
          <a class="ellipses" v-if="paginationUpdate > 0"  v-on:click.prevent="showPastFive(paginationUpdate - 1)" href="#"  id="pagination-back">...<span class="sr-only">Previous Listings</span></a>


          <a class="pageNumber" v-if="totalShowing>1" v-on:click.prevent="getPagination(paginationUpdate + 1)" href="#" id="pagination-first-number">{{paginationUpdate +1}}</a>
          <a class="pageNumber" v-if="(totalShowing - paginationUpdate)>1" v-on:click.prevent="getPagination(paginationUpdate +2)" href="#" id="pagination-second-number">{{paginationUpdate +2}}</a>
          <a class="pageNumber"  v-if="(totalShowing - paginationUpdate) >2" v-on:click.prevent="getPagination(paginationUpdate +3)" href="#" id="pagination-third-number">{{paginationUpdate +3}}</a>
          <a class="pageNumber"  v-if="(totalShowing - paginationUpdate)>3" v-on:click.prevent="getPagination(paginationUpdate +4)" href="#" id="pagination-fourth-number">{{paginationUpdate +4}}</a>
          <a class="pageNumber"  v-if="(totalShowing - paginationUpdate)>4" v-on:click.prevent="getPagination(paginationUpdate +5)" href="#" id="pagination-fifth-number">{{paginationUpdate +5}}</a>
          <a v-bind:class="page"  v-if="(paginationUpdate + 5) < totalShowing" v-on:click.prevent="showNextFive(paginationUpdate)" href="#" class="ellipses" id="pagination-forward">...<span class="sr-only">Next Listings</span></a>

        </div>
      </div>
    </section>
    <section v-else class="post-listing has-after">
      <div class="row listing-container">
        <div class="columns margin-wide no-results_container">
          <h2 >{{this.noResTitle}}</h2>
          <p v-html="this.noResText"></p>
        </div>

      </div>
    </section>

    <div id="app-loading"></div>
  </div>

</template>
<script>



let memberDirectory = document.querySelectorAll('[data-template-id="NG-MemberDirectory"]')
var smoothscroll = require("smoothscroll")
require('es6-promise').polyfill();

import axios from 'axios'

import MemberList from './vueComponents/MemberList.vue'
import ContactListBtn from './vueComponents/ContactListBtn.vue'
import MembersToggle from './vueComponents/MembersToggle.vue'

const api_base = '/api/MemberDirectory/';
const api_state = '/api/MemberState';

let showBudget = isLoggedIn
let results = [];
let bigTotalItems = 0
let displayNumber = numberMembersDisplayed
let isPopState = false
let isLoading = false;


let search = {
  searchType: 'MD',
  states:'',
  cities:[],
  keyword:'',
  institutionType: '',
  budgets: '',
  disciplines: [],
  programTypes: [],
  page: 1
}


export default {
  data() {
    return {
      showBudget: isLoggedIn,
      filterNumber:0,
      isActive: true,
      search: search,
      filterFields: filterFields,
      bigTotalItems: bigTotalItems,
      results: results,
      api: api_base,
      index: 0,
      selectedState:'All States',
      cities: search.cities,
      selectedCity: '',
      page: search.page,
      paginationUpdate: 0,
      totalShowing: 1,
      displayNumber: displayNumber,
      pageNumberElement: 1,
      loading: false,
      noResText: noResultsText,
      noResTitle: noResultsTitle,
      screenWidth: window.innerWidth,
      isPopState: isPopState,
      stateLabel: stateLabel,
      cityLabel: cityLabel,
      keyWordLabel: keyWordLabel,
      institutionaLabel: institutionaLabel,
      budgetLabel: budgetLabel,
      disciplinelabel: disciplinelabel,
      programsLabel: programsLabel,
      beforeAPI: true
    }
  },
components: {
    MemberList,
    ContactListBtn,
    MembersToggle
  },
  methods: {

    getFieldsFromQS: function() {

      //get the current querystring
      var uri = decodeURI(location.search.substr(1));
      //if there isn't one, reset the filter search object to empty values
      if (!uri){
        this.search.budgets = '';
        this.search.keyword = '';
        this.search.disciplines = [];
        this.search.programTypes = [];
        this.search.states = '';
        this.search.cities = '';
        this.search.institutionType = '';
        this.search.page = 1;
        this.searchType = "MD";
        this.isActive = true;
        this.getMembers()
      }
      else {
        //parse the values and add them to the search object for display
      var params = {};
      if (uri) {var chunks = uri.split('&');
        for (var i=0; i < chunks.length ; i++) {
          var chunk = chunks[i].split('=');
          if(chunk[0].search("\\[\\]") !== -1) {
            if( typeof params[chunk[0]] === 'undefined' ) {
            params[chunk[0]] = [chunk[1]];
            } else {
            params[chunk[0]].push(chunk[1]);
            }
          } else {
            params[chunk[0]] = chunk[1];
          }
        }
        //populate the app state (search) with queryString parameters
        this.search.page = (params.page) ? params.page : '';
        this.search.budgets = (params.budgets) ? params.budgets : '';
        this.search.keyword = (params.keyword) ? params.keyword : '';
        this.search.disciplines = (params.disciplines) ? params.disciplines.split(',') : '';
        //make sure disciplines and program types are always arrays
        if (this.search.disciplines === ""){this.search.disciplines = []}
        this.search.programTypes = (params.programTypes) ? params.programTypes.split(',') : '';
        if (this.search.programTypes === ""){this.search.programTypes = []}
        this.search.states = (params.states) ? params.states : '';
        this.search.cities = (params.cities) ? params.cities : '';
        this.search.institutionType = (params.institutionType) ? params.institutionType : '';
      }
      this.getMembers()
      }
    },
    createQuerystring: function(){

      let queryString = Object.keys(search).map(function(key) {
        // Don't return QS values for searchType or currentPage
        if( key === 'searchType' && search.searchType === 'MD'){
          return '';
        } else if(key === 'page' && search.page == 1){
        //   return '';
        }else{
          return (search[key].length !== 0) ? `&${key}=${search[key]}` : '';
        }
      }).join('');

      // Remove first instance of &
      queryString = queryString.substr(1);

      // Prepend ? before querystring
      queryString = (queryString) ? `?${queryString}` : queryString;

      //check if querystring has a plus sign, replace it with API friendly '%2B'
      queryString = queryString.replace('+', '%2B');


      return queryString;

    },

    getMembers: function(api, searchType){

      //set the pagination set to include the current page (multiples of 5)
      if (this.search.page < 5) {this.paginationUpdate = 0}

      else if (parseInt(this.search.page)=== 5.0*Math.floor(this.search.page/5.0)) {
        this.paginationUpdate = (5.0*Math.floor(this.search.page/5.0)) - 5
      }
      else {
          this.paginationUpdate = 5.0*Math.floor(this.search.page/5.0)
      }

      let self = this;
      search.page = this.search.page;
      let params = this.createQuerystring();
      axios.get(`${self.api}${params}`
      ).then(function(response){
          //get total number of members to display
          //console.log(response, 'response', 'qs', self.api + params)
          //console.log(response.data.ResultList)
          self.bigTotalItems = response.data.ResultTotal
          //display results
          self.results = response.data.ResultList
          //console.log(self.results)
          //Find how many pages in total you will show.

          self.totalShowing = Math.ceil(self.bigTotalItems/self.displayNumber)

          //Push url to browser history
          if (history.pushState && !self.isPopState) {
            var newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${params}`;
            window.history.pushState({path:newUrl},'',newUrl);
          }

          self.isPopState = false

          //get current page and set active pagination button
          setTimeout(function(){
            let current = document.querySelectorAll('.pageNumber')
            var arrCurrent = [];
            for(var i = current.length; i--; arrCurrent.unshift(current[i]));
            arrCurrent.map(arrCurr => arrCurr.classList.remove('current'))

            let pageNumberElement = arrCurrent.find(current => current.textContent.includes(self.search.page))
            if (!Array.prototype.find) {
            Array.prototype.find = function(predicate) {
              if (this == null) {
                throw new TypeError('Array.prototype.find called on null or undefined');
              }
              if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
              }
              var list = Object(this);
              var length = list.length >>> 0;
              var thisArg = arguments[1];
              var value;

              for (var i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                  return value;
                }
              }
              return undefined;
            };
          }

            if (pageNumberElement !== undefined){

            pageNumberElement.classList.add('current')

            self.pageNumberElement = pageNumberElement}
          if (self.beforeAPI) {
            let loader = document.querySelector('.bouncing-loader')
            let overlay = document.querySelector('.overlay')
            loader.classList.add('removed')
            overlay.classList.add('removed')
          }
          self.beforeAPI = false
          //Checking for IE browser to create fallback for object-fit
           function msieversion() {

            var ua = window.navigator.userAgent;
             var msie = ua.indexOf("MSIE ");

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
            {

               setTimeout(function() {

                 const image = document.querySelectorAll('.member-logo_image')

                 if(image) {
                    for (var i= 0; i <image.length; i++) {
                       let imageSrc = image[i].getAttribute('src');
                      image[i].style.opacity='0';
                      image[i].parentElement.style.backgroundImage = 'url(' + imageSrc + ')';
                    }
                 }
                        }, 10)
                }
                else  // If another browser, return 0
                {

                }

                    return false;
                }
                msieversion()

           },50)

          //cities are a separate API call based on state (now populated)
           self.getCities()


      });
      //update current QS
      this.params = params
      //update the filter counter with number of search params parsed from queryString
      this.getFilterNumber()
      window.scrollTo(0, 0);


    },
    sendHiddenState: function() {
       //add filter states to hidden inputs for CSV filter
      const hiddenState = document.getElementById('hiddenState')
      hiddenState.value = this.search.states
      const hiddenCity = document.getElementById('hiddenCity')
      hiddenCity.value = this.search.cities
      const hiddenKeyword = document.getElementById('hiddenKeyword')
      hiddenKeyword.value = this.search.keyword
      const hiddenInstitutionType = document.getElementById('hiddenInstitutionType')
      hiddenInstitutionType.value = this.search.institutionType
      const hiddenDisciplines = document.getElementById('hiddenDisciplines')
      hiddenDisciplines.value = this.search.disciplines
      const hiddenBudget = document.getElementById('hiddenBudget')
      hiddenBudget.value = this.search.budgets
      const hiddenProgramTypes = document.getElementById('hiddenProgramTypes')
      hiddenProgramTypes.value = this.search.programTypes
      const hiddenSearchType = document.getElementById('hiddenSearchType')
      hiddenSearchType.value = this.search.searchType
      //console.log(hiddenSearchType.value,hiddenState.value,hiddenCity.value, hiddenKeyword.value, hiddenInstitutionType.value, hiddenDisciplines.value, hiddenBudget.value, hiddenProgramTypes.value)
    },
    getCities: function() {

      let citySelect = document.getElementById('city')
      //reset to default of disabled
      citySelect.disabled= true
      //add disabled class for styling
      citySelect.parentElement.classList.add('disabled')
      //if select has a city, replace it with search results
      while (citySelect.firstChild) {
        citySelect.removeChild(citySelect.firstChild);
      }
      //store selected city from serach results separately during reset
      this.selectedCity = this.search.cities

      this.search.cities = ''
      let vm = this
      //make the api call based on state
      let stateCall = `${api_state}?states=${this.search.states}`;
      axios.get(stateCall
      ).then(function(response){
          vm.cities = response.data

          let cityOption = document.createElement('option')
          //create All cities option, add to select
          cityOption.innerHTML = "All Cities"
          cityOption.setAttribute("value", '')
          citySelect.appendChild(cityOption)
          //if there are cities from search, add them to select and enable select
          if (vm.cities && vm.cities.length > 0) {
              citySelect.disabled= false
              citySelect.parentElement.classList.remove('disabled')
              vm.cities.map(city => {
                  let citySelect = document.getElementById('city')
                  let cityOption = document.createElement('option')
                  cityOption.innerHTML = city
                  cityOption.setAttribute("value", city)
                  cityOption.id = city
                  citySelect.appendChild(cityOption)

              })}
          //set the user selected city in the DOM and search object based on querystring value or user selection
          let selectedCity = document.getElementById(`${vm.selectedCity}`)

          if (selectedCity){
              selectedCity.setAttribute("selected", "selected")
              vm.search.cities = selectedCity.textContent

          }
      });
    },
    toggle: function(event){
      event.preventDefault();
      let target = event.target;
      // Exit if .active
      if(target.classList.contains('active')){
        return false;
      }
      // Add/Remove .active class
      let selected = target.dataset.id;
      let btns = document.querySelectorAll('.members-toggle--btn');
      [...btns].forEach((btn, index) => {
        let id = btn.dataset.id;
        if(selected === id){ // Selected element
          this.setSelected(index);
          this.index = index;
        } else {
          btn.classList.remove('active');
        }
      });
      //set searchtype
      if (selected ==="affiliates"){
        this.search.searchType = "BA"
        this.showHideFilter()
      } else {
        this.search.searchType = "MD"
        this.showHideFilter()
      }
    },
    setSelected: function(index){
      let parent = document.querySelector('.members-toggle');
      let btns = document.querySelectorAll('.members-toggle--btn');
      let highlight = document.querySelector('.members-toggle span');
      let btn = btns[index];
      let width = btn.offsetWidth;
      let left = btn.offsetLeft;

      setTimeout(function(){
        btn.classList.add('active');
      }, 125);

      highlight.style.width = `${width}px`;
      highlight.style.left = `${left}px`;
    },
    parseValue: function(state) {
      //convert state objects to display strings
      for (var key in state) {
        if (state.hasOwnProperty(key)){
        return (state[key])
        }
      }
    },
    getFilterNumber: function() {
      //incrememnt the filter counter when fields are added
      let stateValue = this.search.states.length
      let cityValue = this.search.cities.length
      let keywordValue = this.search.keyword.length
      let institutionValue = this.search.institutionType.length
      let budgetValue = this.search.budgets.length
      let programTypesValue = this.search.programTypes.length
      let disciplinesValue = 0



      if (stateValue > 0 ){stateValue = 1}
      if (cityValue > 0 ){cityValue = 1}
      if (keywordValue > 0 ){keywordValue = 1}
      if ( budgetValue > 0 ){ budgetValue = 1}
      if (institutionValue > 0 ){ institutionValue = 1}

      if (this.search.programTypes[0] === '') {
        programTypesValue = programTypesValue
      } else {
        programTypesValue = this.search.programTypes.length
      }

      if (this.search.disciplines === true)
      {
        disciplinesValue = 0
      } else if (this.search.disciplines[0] || this.search.disciplines[0] === '') {
        disciplinesValue = this.search.disciplines.length
        disciplinesValue = disciplinesValue
      } else {
        disciplinesValue = this.search.disciplines.length
      }

      if (this.search.budgets.length >= 1 ){budgetValue = 1}
      let count = disciplinesValue + programTypesValue + stateValue + cityValue + keywordValue + institutionValue + budgetValue
      this.filterNumber = count
    },
    setPageToOne: function() {
      //if filter fields change, reset pagenumber for the new set of results
        this.search.page = 1
        this.paginationUpdate = 0
    },
    filterReset: function() {

      //reset all filter values
      this.search.disciplines = []
      this.search.budgets = ''
      this.search.keyword = ''
      this.search.cities = ''
      this.search.states = ''
      this.search.programTypes = []
      this.search.institutionType = ''
      this.filterNumber = 0
      this.search.page = 1
      this.paginationUpdate = 0;
      //add this value to pushState so the browser stores it for back button
      var oldUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
      window.history.pushState({path:oldUrl},'',oldUrl)
      //update results
      this.getMembers(this.api)

    },
    filterResetDisciplines: function() {
      //only reset the disciplines field
      this.search.disciplines = []
      this.getFilterNumber()
    },
    filterResetProgramTypes: function() {
      //only reset the program types field
      this.search.programTypes = []
      this.getFilterNumber()
    },
    showHideFilter: function() {
      //hide entire filter including filter bar if members are searching business affiliates
      let filter = document.querySelector('.member-filter-container')

      if (this.search.searchType === "MD"){
        filter.classList.add('active')
        }
      if (this.search.searchType === "BA") {
        filter.classList.remove('active')
        }
    },
    filterOpenClose: function() {
      //open and close filter from bar, hide inputs when closed so they don't recieve focus when visually removed.
        let filter = document.querySelector('.filter-container')
        let formFocusables = document.querySelectorAll('.hide-on-collapse')
          //hide all inputs so they won't be keyboard accessible when filter is closed
              for (var i = 0; i < formFocusables.length; ++i) {
                  formFocusables[i].classList.remove('hidden')
                  }
        if (this.isActive === true){
          this.isActive = false
          //reveal all inputs so they are accessible
              let formFocusables = document.querySelectorAll('.hide-on-collapse')
              for (var i = 0; i < formFocusables.length; ++i) {
                  formFocusables[i].classList.add('hidden')
                  }
          setTimeout(function() {
            filter.classList.add('height')
          },325)
        } else {
          //hide all inputs so they don't recieve focus when viusally removed.
          this.isActive = true
          let formFocusables = document.querySelectorAll('.hide-on-collapse')
              for (var i = 0; i < formFocusables.length; ++i) {
                  formFocusables[i].classList.remove('hidden')
                }
            filter.classList.remove('height')
            this.getCities()
        }
    },
    showLoader: function() {
      //show loader during longer searches
      this.loading = true;
      let self = this
      setTimeout(function() {
        self.loading = false
      },900)
    },
    filterClose: function() {
      //close the filter
       let filter = document.querySelector('.filter-container')
      this.isActive = false
        let formFocusables = document.querySelectorAll('.hide-on-collapse')
              for (var i = 0; i < formFocusables.length; ++i) {
                  formFocusables[i].classList.add('hidden')
                  }
          setTimeout(function() {
            filter.classList.add('height')
          },325)
    },
    handleResize() {
      //make js computed sizes reactive to changing screen size
      let filter = document.querySelector('.filter-container')
      this.setSelected(this.index);
      let app = document.getElementById('app')
      this.screenWidth = app.offsetWidth
    },
    baSearch: function(e) {
      //toggle to the Business Affiliate search, while saving Member Directory search.
      let self = this;
      let params = `?searchType=BA`
      axios.get(`${self.api}${params}`
      ).then(function(response){
          self.bigTotalItems = response.data.ResultTotal
          self.results = response.data.ResultList
          if (history.pushState) {
            var newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${params}`;
            window.history.pushState({path:newUrl},'',newUrl);
          }
                     function msieversion() {

            var ua = window.navigator.userAgent;
             var msie = ua.indexOf("MSIE ");

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
            {

               setTimeout(function() {

                 const image = document.querySelectorAll('.member-logo_image')

                 if(image) {
                    for (var i= 0; i <image.length; i++) {
                       let imageSrc = image[i].getAttribute('src');
                      image[i].style.opacity='0';
                      image[i].parentElement.style.backgroundImage = 'url(' + imageSrc + ')';
                    }
                 }
                        }, 10)
                }
                else  // If another browser, return 0
                {

                }

                    return false;
                }
                msieversion()
      });
    },
    getPagination: function(pageNumber) {
      //Get members pased on page number user clicks.  Scroll to top while search populates results.
      if (pageNumber === 1){
        this.paginationUpdate = 0
      }
      this.search.page =  pageNumber
      let siteHeader = document.getElementById('site-header')
      smoothscroll(siteHeader)
      this.getMembers()
      window.scrollTo(memberTop)
      //set focus back to the top of the search filter
        let filterTop = document.querySelector('.filterCollapse');
        filterTop.focus()


    },
    showNextFive: function(pageNumber){
      //get next five set of pagination numbers
        this.paginationUpdate = pageNumber + 5
        this.search.page = this.paginationUpdate + 1
        let siteHeader = document.getElementById('site-header')
      smoothscroll(siteHeader)
      this.getMembers()
      //set focus back to the top of the search filter
        let filterTop = document.querySelector('.filterCollapse');
        filterTop.focus()

    },
    showPastFive: function(pageNumber) {
      //get last five set of pagination numbers
      this.paginationUpdate = pageNumber - 4
      this.search.page = this.paginationUpdate + 5
      let siteHeader = document.getElementById('site-header')
      smoothscroll(siteHeader)
      this.getMembers()
      //set focus back to the top of the search filter
        let filterTop = document.querySelector('.filterCollapse');
        filterTop.focus()

    },
    preventEnterSubmit: function(event) {
      //prevent checkboxes from submitting on Enter
      event.keyCode === 13 ? event.preventDefault() : false
    },
    submitOnEnter: function(event) {
      //submit on enter after keyword search
      if (event.keyCode === 13){
        event.preventDefault()
        this.showLoader()
        this.getMembers()
        this.filterClose()
        this.getFilterNumber()
      }
    },
    backButton: function() {
      this.isPopState = true;
      this.getFieldsFromQS()
    }
  },
  beforeMount: function() {
    this.getFieldsFromQS()
  },

  mounted: function(){
    //toggle styles
    let index = this.index;
    let btns = document.querySelectorAll('.members-toggle--btn');
    let highlight = document.querySelector('.members-toggle span');
    let btn = btns[index];
    let width = btn.offsetWidth;

    highlight.style.width = `${width}px`;
    highlight.style.opacity = 1;

    setTimeout(function(){
      highlight.classList.add('in-view');
    }, 350);


    this.setSelected(this.index);
    if (this.isActive === true && this.screenWidth < 768){
          this.isActive = false
          let filter = document.querySelector('.filter-container')
            setTimeout(function() {
            filter.classList.add('height')
          },325)
        }
  },
  created: function() {
      //check system to see whether user is logged in
      this.showBudget = isLoggedIn
      window.addEventListener("popstate", this.backButton, false);

  },
  updated: function() {
    let listingContainer = document.querySelector('.has-after')
  if(listingContainer){
    //console.log(listingContainer)
    let templateBackground = listingContainer.querySelector('.no-results_container')
  if (templateBackground){
    //console.log(templateBackground.parentElement.parentElement)
      templateBackground.parentElement.parentElement.classList.add('after-removed')
}
}
    this.setSelected(this.index);
    this.showBudget = isLoggedIn
        if (!this.isActive) {
            let formFocusables = document.querySelectorAll('.hide-on-collapse')
              for (var i = 0; i < formFocusables.length; ++i) {
                  formFocusables[i].classList.add('hidden')
                }
            }
            if (this.isActive) {
              let formFocusables = document.querySelectorAll('.hide-on-collapse')
              for (var i = 0; i < formFocusables.length; ++i) {
                  formFocusables[i].classList.remove('hidden')
                }
            }
  }
}
</script>



// WEBPACK FOOTER //
// CMS/NationalGuild/src/js/App.vue